<mat-card appearance="outlined">
    <form class="fix-editor">
        <mat-form-field class="ag-row fix-mat-form" [style.width]="width()">
            <input
                matInput
                [formControl]="alphanumericFormControl()"
                [sanitizeChars]="notAdmissibleCharsRegexp()"
                [focusSelectOn]="cellReady()"
            />
            @if (alphanumericFormControl().hasError("required")) {
                <mat-error>
                    {{ "se-ui-datagrid_required_value_constraint" | translate }}
                </mat-error>
            }
        </mat-form-field>
    </form>
</mat-card>
